<script>
import aboutContent from './global/about-content'

export default {
   name: 'about',
   metaInfo: {
      title: 'About Us',
      titleTemplate: '%s | Juilliard Creative Classroom',
   },
   props: [],
   components: {
      aboutContent,
   },
   data() {
      return {
         title: null,
         content: null,
      }
   },
   computed: {},
   methods: {},
   beforeMount() {
      this.$store.dispatch('getStaticPage', 'about').then(res => {
         this.title = res.body.data.title
         this.content = res.body.data.content[0].attributes
      })
   },
}
</script>

<template>
   <section class="about-page" v-if="content">
      <div class="img-holder">
         <img
         v-if="content.image"
         :src="content.image.src"
            alt="about-hero-image"
         />
      </div>

      <aboutContent :content="content" :title="title" />
   </section>
</template>
